import React from 'react';
const HourglassIcon = ({ size=18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2h12v4l-4 4 4 4v4H6v-4l4-4-4-4V2z" />
  </svg>
);
export default HourglassIcon;